import React from "react"

const DisclosureNotesContext = React.createContext({})

const { Provider, Consumer } = DisclosureNotesContext

export { Provider, Consumer, DisclosureNotesContext }
